import { forwardRef, createElement } from 'react';
import selectStyles from './SelectInput.module.scss.js';
import styles from '../Inputs.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { UNSAFE_Icon } from '../../icon/Icon.js';
import classNames from 'clsx';
import { MdKeyboardArrowDown } from '../../node_modules/react-icons/md/index.js';

/**
 * A dropdown input.
 */
const SelectInput = /*#__PURE__*/forwardRef(function SelectInput(props, forwardedRef) {
  const {
    autoComplete = 'off',
    className: callerClassName,
    name,
    options,
    tag = name,
    variant = 'default',
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...selectProps
  } = props;
  const containerClassName = classNames('dsx-component', styles['arrow-wrapper']);
  const selectClassName = classNames(callerClassName, selectStyles['select'], styles['input-box'], styles['input'], styles['arrow-input'], styles[variant], UNSAFE_active && styles['active'], UNSAFE_hover && styles['hover'], UNSAFE_focus && styles['focus']);
  return /*#__PURE__*/jsxs("span", {
    className: containerClassName,
    children: [/*#__PURE__*/jsx("select", {
      ...selectProps,
      autoComplete: autoComplete,
      className: selectClassName,
      name: name,
      ref: forwardedRef,
      "data-dsx--select-input": tag,
      children: options.map(optionProps => /*#__PURE__*/createElement("option", {
        ...optionProps,
        key: optionProps.value,
        "data-dsx--select-input--option": optionProps.value
      }, optionProps.label))
    }), /*#__PURE__*/jsx("div", {
      "aria-hidden": true,
      className: styles['arrow'],
      children: /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdKeyboardArrowDown
      })
    })]
  });
});

export { SelectInput };
